export const ChapterLabel = ({ number, testId }) => (
  <div data-testid={testId} className="mb-6 flex items-center gap-4">
    <span className="text-sm font-bold tracking-[0.3em] text-[#8B7CF6]">
      {number}
    </span>
    <span className="h-px w-16 bg-[#8B7CF6]/30" />
  </div>
);
